import { ApiService } from "src/network/apiService";
import { IApplicationModel } from "src/types/models/apiModels";

export class ApplicationListViewModel {
	private apiService: ApiService;

	constructor(accessToken: string) {
		this.apiService = new ApiService({ accessToken: accessToken });
	}

	async deleteBrandingApplicationAsync(applicationToDelete: IApplicationModel): Promise<boolean> {
		const response = await this.apiService.deleteAsync<any, undefined>(
			`/onboard/application/${applicationToDelete.applicationId}`
		);

		if (response) {
			if (response.scResponse && response.scResponse.code === 2000) {
				return true;
			}

			return false;
		}

		return false;
	}

	async fetchListAsync(): Promise<IApplicationModel[]> {
		const response = await this.apiService.getAsync<any>(
			"/onboard/applications"
		);

		if (response) {
			if (response.scResponse && response.scResponse.code === 2000) {
				// console.log(`response -> ${JSON.stringify(response.scResponse.data)}`)
				return response.scResponse.data;
			}

			return [];
		}

		return [];
	}
}
